:root {
  /* 'EmojiMart' represents the general emoji font of the app, themes may redefine it */
  --emojifonts: "EmojiMart", "Apple Color Emoji", NotoEmoji;
  --fonts-default:
    Roboto, var(--emojifonts), "Helvetica Neue", Arial, Helvetica, NotoMono,
    sans-serif;
  --fonts-system: system-ui, var(--fonts-default);
}

/* Theming Colors */
.qrReader {
  position: relative;
  height: 375px;
  margin-bottom: 20px;
}
@media (max-width: 500px) {
  .qrReader {
    height: auto;
    min-height: 375px;
    flex: 1 1 auto;
  }
}

.qrReaderVideo {
  display: none;
  height: 100%;
  width: 100%;
  object-fit: cover;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}
.qrReaderVideo.visible {
  display: block;
}
.qrReaderVideo.flipped {
  transform: scale(-1, 1);
}

.qrReaderButton {
  background-color: white;
  border-radius: 50%;
  border: 0;
  bottom: 0;
  filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.2));
  height: 35px;
  margin: 15px;
  padding: 5px;
  position: absolute;
  right: 5px;
  width: 35px;
}
.qrReaderButton:hover {
  filter: drop-shadow(1px 1px 2px rgba(0, 0, 0, 0.4));
}

.qrReaderButtonIcon {
  background-color: #333;
}

.qrReaderStatus {
  align-items: center;
  color: white;
  display: flex;
  height: 375px;
  justify-content: center;
  left: 0;
  padding: 50px;
  position: absolute;
  right: 0;
  text-align: center;
  top: 0;
}
@media (max-width: 500px) {
  .qrReaderStatus {
    height: auto;
    bottom: 0;
  }
}
.qrReaderStatus.info {
  background-color: gray;
}
.qrReaderStatus.error {
  background-color: red;
}

.qrReaderError {
  display: block;
}

.qrReaderOverlay {
  border: 40px solid rgba(0, 0, 0, 0.2);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
}

.qrReaderHint {
  bottom: 0;
  color: white;
  left: 0;
  padding: 10px;
  position: absolute;
  right: 0;
  text-align: center;
  user-select: none;
}

.qrReaderScanLine {
  animation-direction: alternate;
  animation-duration: 0.6s;
  animation-iteration-count: infinite;
  animation-name: pulsating;
  animation-timing-function: ease-in;
  border-bottom-color: rgba(255, 255, 255, 0.3);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  left: 50px;
  position: absolute;
  right: 50px;
  top: 50%;
}
@keyframes pulsating {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.qrReaderFileInput {
  display: none;
}